// ProfileImageContainer.js
import React from 'react';
import '../../styles/components/profile_page/ProfileImageContainer.css';

const ProfileImageContainer = ({ profileImageUrl}) => {
    return (
        <div className="profile-image-container">
            <img
                key={profileImageUrl}
                src={profileImageUrl}
                alt="Profile"
                className="profile-image"
                onError={(e) => {
                    e.target.src = "/images/default_profile_picture.png";
                }}
            />
        </div>
    );
};

export default ProfileImageContainer;